var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: {
            option: _vm.option,
            data: _vm.tableData,
            "span-method": _vm.objectSpanMethod,
          },
          on: {
            "refresh-change": _vm.refreshChange,
            "sortable-change": _vm.sortableChange,
          },
          scopedSlots: _vm._u([
            {
              key: "myIndex",
              fn: function (scope) {
                return [
                  _c("span", [
                    _vm._v(
                      " " + _vm._s(scope.row.template && scope.row.template.id)
                    ),
                  ]),
                ]
              },
            },
            {
              key: "appType",
              fn: function (scope) {
                return [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.condition.appType === 1 ? "渠道" : "平台"
                        )
                    ),
                  ]),
                ]
              },
            },
            {
              key: "commonTemplateId",
              fn: function (scope) {
                return [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.template && scope.row.template.name)
                    ),
                  ]),
                ]
              },
            },
            {
              key: "appInfo",
              fn: function (scope) {
                return [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          +scope.row.appInfo === 0
                            ? "全部渠道"
                            : scope.row.appInfo
                        )
                    ),
                  ]),
                ]
              },
            },
            {
              key: "model",
              fn: function (scope) {
                return [
                  _c("div", [
                    _c("div", [
                      _vm._v(
                        "厂商： " +
                          _vm._s(
                            scope.row.condition &&
                              scope.row.condition.manufacturer
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "品牌： " +
                          _vm._s(
                            scope.row.condition && scope.row.condition.brand
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "型号： " +
                          _vm._s(
                            scope.row.condition && scope.row.condition.model
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "uid",
              fn: function (scope) {
                return [
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.condition && scope.row.condition.uid) +
                        "\n      "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "uuid",
              fn: function (scope) {
                return [
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.condition && scope.row.condition.uuid
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "sdkVersion",
              fn: function (scope) {
                return [
                  _c("div", [
                    _c("div", [
                      _vm._v(
                        "应用版本： " +
                          _vm._s(
                            scope.row.condition &&
                              scope.row.condition.appVersion
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "SDK版本： " +
                          _vm._s(
                            scope.row.condition &&
                              scope.row.condition.sdkVersion
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "myOption",
              fn: function (scope) {
                return [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "APPS_CHANNELSDKCONFIG_COPY",
                              expression: "'APPS_CHANNELSDKCONFIG_COPY'",
                            },
                          ],
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.toCopy(scope.row.id)
                            },
                          },
                        },
                        [_vm._v("\n          复制\n        ")]
                      ),
                      scope.row.auditStatus != 2
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "APPS_CHANNELSDKCONFIG_EDIT",
                                  expression: "'APPS_CHANNELSDKCONFIG_EDIT'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.toEdit(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("\n          编辑\n        ")]
                          )
                        : _vm._e(),
                      scope.row.auditStatus === 1 || scope.row.auditStatus === 2
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "APPS_CHANNELSDKCONFIG_EDIT",
                                  expression: "'APPS_CHANNELSDKCONFIG_EDIT'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleReview(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  scope.row.auditStatus === 1
                                    ? "提交审核"
                                    : "撤销审核"
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      scope.row.auditStatus != 2
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "APPS_CHANNELSDKCONFIG_DEL",
                                  expression: "'APPS_CHANNELSDKCONFIG_DEL'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.delItem(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("\n          删除\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "menu",
              fn: function (scope) {
                return [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "APPS_CHANNELSDKCONFIG_LOG",
                          expression: "'APPS_CHANNELSDKCONFIG_LOG'",
                        },
                      ],
                      attrs: { type: "text", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.openLog(scope.row.template.id)
                        },
                      },
                    },
                    [_vm._v("\n        操作日志\n      ")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "mySearch" }, [
            _c("div", { staticClass: "search-contain" }, [
              _c(
                "div",
                { staticClass: "search-left" },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "策略名称" },
                    model: {
                      value: _vm.params.search,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "search", $$v)
                      },
                      expression: "params.search",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "200px !important",
                        "margin-left": "20px",
                      },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "配置开关",
                        multiple: "",
                      },
                      model: {
                        value: _vm.params.templateIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "templateIds", $$v)
                        },
                        expression: "params.templateIds",
                      },
                    },
                    _vm._l(_vm.templateList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                  _c("DynamicOption", {
                    staticStyle: {
                      width: "200px",
                      "margin-left": "20px",
                      "margin-right": "20px",
                    },
                    attrs: { placeholder: _vm.渠道 },
                    model: {
                      value: _vm.params.channelIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "channelIds", $$v)
                      },
                      expression: "params.channelIds",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "200px !important",
                        "margin-right": "20px",
                      },
                      attrs: { clearable: "", placeholder: "审核状态" },
                      model: {
                        value: _vm.params.auditStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "auditStatus", $$v)
                        },
                        expression: "params.auditStatus",
                      },
                    },
                    _vm._l(
                      [
                        { label: "草稿", value: 1 },
                        { label: "待审核", value: 2 },
                        { label: "审核通过", value: 3 },
                        { label: "审核不通过", value: 4 },
                      ],
                      function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }
                    ),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "APPS_CHANNELSDKCONFIG_SEARCH",
                          expression: "'APPS_CHANNELSDKCONFIG_SEARCH'",
                        },
                      ],
                      attrs: { icon: "el-icon-search", type: "primary" },
                      on: { click: _vm.getDataList },
                    },
                    [_vm._v("\n            搜索\n          ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "_delete_btn",
                      attrs: { icon: "el-icon-delete" },
                      on: {
                        click: () => {
                          ;(_vm.params.channelIds = []),
                            (_vm.params.templateIds = []),
                            (_vm.params.search = "")
                        },
                      },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "search-left",
                  staticStyle: {
                    width: "500px",
                    position: "relative",
                    "margin-top": "20px",
                    "margin-bottom": "-4vw",
                    "z-index": "1 !important",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "APPS_CHANNELSDKCONFIG_ADD",
                          expression: "'APPS_CHANNELSDKCONFIG_ADD'",
                        },
                      ],
                      staticClass: "_delete_btn",
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.toEdit()
                        },
                      },
                    },
                    [_vm._v("+\n            新增")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "APPS_CHANNELSDKCONFIG_Hit",
                          expression: "'APPS_CHANNELSDKCONFIG_Hit'",
                        },
                      ],
                      staticClass: "_delete_btn",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.queryDeatils },
                    },
                    [_vm._v("\n            命中配置查询 ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { "text-align": "right", padding: "20px" },
        attrs: {
          "current-page": _vm.params.current,
          "page-sizes": [10, 20, 40, 50, 100],
          "page-size": _vm.params.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.params.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _vm.dialogVisible
        ? _c("channelSdkConfigEdit", {
            attrs: { id: _vm.toEditid, copyId: _vm.copyId },
            on: { input: _vm.handleEditClose },
            model: {
              value: _vm.dialogVisible,
              callback: function ($$v) {
                _vm.dialogVisible = $$v
              },
              expression: "dialogVisible",
            },
          })
        : _vm._e(),
      _vm.dialogVisibleDeatils
        ? _c("channelSdkConfigDeatils", {
            model: {
              value: _vm.dialogVisibleDeatils,
              callback: function ($$v) {
                _vm.dialogVisibleDeatils = $$v
              },
              expression: "dialogVisibleDeatils",
            },
          })
        : _vm._e(),
      _c("ChannelSdkConfigLogVue", {
        attrs: { logVisible: _vm.logVisible, id: _vm.logId },
        on: {
          "update:logVisible": function ($event) {
            _vm.logVisible = $event
          },
          "update:log-visible": function ($event) {
            _vm.logVisible = $event
          },
          "update:id": function ($event) {
            _vm.logId = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }